import { render, staticRenderFns } from "./Flujo.vue?vue&type=template&id=141c6012&scoped=true"
import script from "./Flujo.vue?vue&type=script&lang=js"
export * from "./Flujo.vue?vue&type=script&lang=js"
import style0 from "./Flujo.vue?vue&type=style&index=0&id=141c6012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c6012",
  null
  
)

export default component.exports